'use client';

import Link from 'next/link';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import type { NavItem } from './sidebar';

type Props = {
  items: NavItem[];
  activeHref: string;
  children?: React.ReactNode;
};

const SidebarChips = ({ items, activeHref, children }: Props) => {
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        overflowX: 'auto',
        pb: 0.5,
        mb: 2,
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
      }}
    >
      {items.map((item) => {
        const isActive = item.href === activeHref;
        return (
          <Chip
            key={item.href}
            label={item.label}
            icon={item.icon as React.ReactElement}
            component={Link}
            href={item.href}
            clickable
            color={isActive ? 'primary' : 'default'}
            variant={isActive ? 'filled' : 'outlined'}
            sx={{ flexShrink: 0 }}
          />
        );
      })}
      {children}
    </Stack>
  );
};

export default SidebarChips;
